import { useEffect, useState } from 'react';

import { fetchListOfBanks } from '../api';

const useListOfBanks = (countryCode = 'NG') => {
  const [availableBanks, setAvailableBanks] = useState([]);

  useEffect(async () => {
    const banks = await fetchListOfBanks(countryCode);
    setAvailableBanks(banks);
  }, [countryCode]);

  return { availableBanks };
};

export { useListOfBanks };
